import RobotFields
    from "../fields/RobotFields";

import EtiquetageFields
    from "../fields/EtiquetageFields";

export default function MedicamentFieldsRenderer({ produit, onChange, strategy, commande }) {

    const currentStrategy =
        strategy?.[produit.destination]
        || strategy
        || {};

    return (
        <>
            {currentStrategy.showRobotFields && (
                <RobotFields
                    produit={produit}
                    onChange={onChange}
                    commande={commande}
                />
            )}

            {currentStrategy.showEtiquetageFields && (
                <EtiquetageFields
                    produit={produit}
                    onChange={onChange}
                    commande={commande}
                />
            )}
        </>
    );
}